import React from "react";
import { Container, Row, Col, Button, Accordion } from "react-bootstrap";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const NextArrow = ({ onClick }) => (
  <div className="slider-arrow next" onClick={onClick}>
    <FaChevronRight />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="slider-arrow prev" onClick={onClick}>
    <FaChevronLeft />
  </div>
);

const SikkimPackage = () => {

  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className="package-detail">

      {/* HERO BANNER */}
      <div
        className="package-hero-banner"
        style={{
          backgroundImage:
            "url('/Images/tour/Sikkim.jpg')",
        }}
      >
        <Container>
          <div className="hero-content">
            <h1>Sikkim Himalayan Explorer</h1>

            <p className="hero-subtitle">
              4 Nights / 5 Days • Gangtok & Tsomgo Lake Tour
            </p>

            <div className="hero-price">
              Starting From <span>₹24,999</span> / Per Person
            </div>
          </div>
        </Container>
      </div>

      <Container className="package-container">

        {/* SLIDER + FORM */}
        <Row className="mb-4">

          {/* LEFT SLIDER */}
          <Col lg={8}>
            <div className="package-slider">
              <Slider {...sliderSettings}>
                <img src="/Images/tour/Sikkim.jpg" alt="" />
                <img src="/Images/tour/sikkim1.jpg" alt="" />
                <img src="/Images/tour/sikkim2.jpeg" alt="" />
              </Slider>
            </div>
          </Col>

          {/* RIGHT FORM */}
          <Col lg={4}>
            <div className="enquiry-sidebar">
              <h2>₹24,999</h2>
              <p>Per Person</p>

              <Button variant="danger" className="mb-3">
                Book Now
              </Button>

              <form>
                <input type="text" placeholder="Your Name" />
                <input type="text" placeholder="Mobile Number" />
                <input type="date" />
                <input type="number" placeholder="Persons" />
                <textarea placeholder="Message"></textarea>

                <Button variant="dark">Send Enquiry</Button>
              </form>
            </div>
          </Col>
        </Row>

        {/* MAIN CONTENT */}
        <Row>
          <Col lg={8}>

            <div className="package-header">
              <h1>Sikkim Himalayan Explorer</h1>
              <p>4 Nights / 5 Days • Gangtok Sightseeing</p>
            </div>

            {/* Highlights */}
            <div className="content-box highlight-box">
              <h3>Tour Highlights</h3>

              <Row>
                <Col md={6}>✔ Tsomgo Lake Excursion</Col>
                <Col md={6}>✔ Baba Mandir Visit</Col>
                <Col md={6}>✔ MG Marg Walk</Col>
                <Col md={6}>✔ Himalayan Monastery Tour</Col>
              </Row>
            </div>

            {/* Overview */}
            <div className="content-box">
              <h3>Overview</h3>
              <p>
                Explore the breathtaking beauty of Sikkim with scenic
                mountains, pristine lakes, Buddhist monasteries and
                vibrant local culture. Experience Gangtok’s charm and
                Himalayan serenity.
              </p>
            </div>

            {/* Itinerary */}
            <div className="content-box">
              <h3>Day Wise Itinerary</h3>

              <Accordion defaultActiveKey="0">

                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    Day 1 – Arrival Gangtok
                  </Accordion.Header>
                  <Accordion.Body>
                    Arrival at Bagdogra/NJP and transfer to Gangtok.
                    Evening free for leisure at MG Marg.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    Day 2 – Gangtok Sightseeing
                  </Accordion.Header>
                  <Accordion.Body>
                    Visit Rumtek Monastery, Tashi View Point,
                    Flower Exhibition Centre and local attractions.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    Day 3 – Tsomgo Lake & Baba Mandir
                  </Accordion.Header>
                  <Accordion.Body>
                    Excursion to Tsomgo Lake and Baba Mandir with
                    stunning Himalayan views.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    Day 4 – Leisure Day
                  </Accordion.Header>
                  <Accordion.Body>
                    Explore local markets, cafes and optional
                    sightseeing or shopping.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    Day 5 – Departure
                  </Accordion.Header>
                  <Accordion.Body>
                    Breakfast and transfer for onward journey.
                  </Accordion.Body>
                </Accordion.Item>

              </Accordion>
            </div>

            {/* Inclusion / Exclusion */}
            <div className="content-box">
              <Row>

                <Col md={6}>
                  <h4>Inclusions</h4>
                  <ul className="inclusion-list">
                    <li>Hotel Accommodation</li>
                    <li>Daily Breakfast</li>
                    <li>Private Transfers</li>
                    <li>Local Sightseeing</li>
                  </ul>
                </Col>

                <Col md={6}>
                  <h4>Exclusions</h4>
                  <ul className="exclusion-list">
                    <li>Airfare / Train Fare</li>
                    <li>Permit Charges</li>
                    <li>Personal Expenses</li>
                    <li>Adventure Activities</li>
                  </ul>
                </Col>

              </Row>
            </div>

            {/* Gallery */}
            <div className="content-box">
              <h3>Gallery</h3>

              <Row className="gallery">
                <Col md={4}>
                  <img src="/Images/tour/Sikkim.jpg" alt="" />
                </Col>
                <Col md={4}>
                  <img src="/Images/tour/sikkim1.jpg" alt="" />
                </Col>
                <Col md={4}>
                  <img src="/Images/tour/sikkim2.jpeg" alt="" />
                </Col>
              </Row>
            </div>

          </Col>
        </Row>

      </Container>
    </div>
  );
};

export default SikkimPackage;